// globals
class AccordionEvent {
  constructor() {
    this.event();
  }
  event() {

    if (window.matchMedia('(max-width: 767px)').matches) {
      //スマホ処理
      const elements = document.querySelectorAll(".s-gift__item02-inner");
      Array.from(elements).forEach(function (el) {
        //ボタンを取得
        const btn = el.querySelector(".more__btn");
        //コンテンツを取得
        const content = el.querySelector(".more__content");
        //ボタンクリックでイベント発火
        btn.addEventListener("click", function () {
          $('.more__btn').toggleClass('is-active');
          if (!content.classList.contains("open")) {
            //コンテンツの実際の高さを代入
            //キーワード値（none、max-content等）では動作しないので注意
            content.style.maxHeight = content.scrollHeight + "px";
            //openクラスを追加
            content.classList.add("open");
          } else {
            //コンテンツの高さを固定値を代入
            content.style.maxHeight = "27.5rem";
            //openクラスを削除
            content.classList.remove("open");
          }
        });
      });
    } else if (window.matchMedia('(min-width:768px)').matches) {
      //PC処理
      const elements = document.querySelectorAll(".s-gift__item02-inner");
      Array.from(elements).forEach(function (el) {
        //ボタンを取得
        const btn = el.querySelector(".more__btn");
        //コンテンツを取得
        const content = el.querySelector(".more__content");
        //ボタンクリックでイベント発火
        btn.addEventListener("click", function () {
          $('.more__btn').toggleClass('is-active');
          if (!content.classList.contains("open")) {
            //コンテンツの実際の高さを代入
            //キーワード値（none、max-content等）では動作しないので注意
            content.style.maxHeight = content.scrollHeight + "px";
            //openクラスを追加
            content.classList.add("open");
          } else {
            //コンテンツの高さを固定値を代入
            content.style.maxHeight = "32rem";
            //openクラスを削除
            content.classList.remove("open");
          }
        });
      });
    }
  }
}

class Achievement {
  constructor(el,opt){
    this.el = el;
    if($("#" + this.el).length > 0){
      this.event();
    }
  }
  event() {
    let choice = {
      'ワンオンチャレンジ': ['お煎餅セット','スポーツブランドタオルセット','洗剤セット','入浴剤セット','メンズ・レディース軽量折りたたみ傘2本セット','洋菓子セット','和菓子セット','朝食のお供セット','調味料セット','ドリップ＆スティックコーヒーセット'],
      'ワンピンチャレンジ': ['サーロインステーキセット','オリジナル干物セット','肉餃子100個セット','国産牛ハンバーグセット','佐野ラーメン人気繁盛店セット','フランス産ワインセット','高級赤玉たまご50個'],
      'ホールインワンチャレンジ':['ビール1年分']
    }

    console.log(choice);

    if($('.mw_wp_form_input').length) {
      $('.js-form-item').css({'display': 'none'});
      $('.js-form-item option').wrap('<span></span>');

      if($('[name="challengeselect"]').val()) {
        el_change($('[name="challengeselect"]').val());
      }

      $('[name="challengeselect"]').change(function() {
        el_change($(this).val());
        // console.log($(this).val());
      })

      function el_change(el_val) {
        $('.js-form-item').css({'display': 'block'});
        $('.js-form-item select').val('');
        $('.js-form-item option').each(function(index,el) {
          // console.log(el);
          if($(el).parent()[0].localName != 'span') {
            $(el).wrap('<span></span>');
          }
        })
        choice[el_val].forEach(val => {
          $('.js-form-item option').each((index, el) => {
            if($(el).attr('value') === val) {
              $(el).unwrap();
            }
          });
        });
        $('.js-form-item select').val($('.js-form-item select > option').eq(0).val());
      }
    }
  }
}
var CFL = {
  UA: {
    raw: function raw() {
      return navigator.userAgent;
    },
    is: function is(_is) {
      var ua = CFL.UA.raw();
      if (_is === 'issp') {
        return CFL.UA.isSp();
      }
    },
    isSp: function isSp() {
      var ua = CFL.UA.raw();
      return ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0;
    },
    isTablet: function() {
      var ua = CFL.UA.raw();
      if(ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
      } else if (ua.indexOf('iPad') > -1
         || (ua.indexOf('Macintosh') > -1 && CFL.UA.Device.isTouch() )
         || ua.indexOf('Android') > 0) {
        return true;
      }

      return false;
    },
    isEdge: function() {
      return this.raw().indexOf('Edge') != -1;
    },
    isIE: function() {
      var ua = CFL.UA.raw();
      return this.raw().indexOf('Trident') != -1 ;
    }
  },
  Device: {
    isTouch: function() {
      return 'ontouchend' in document;
    }
  }
};

var isMobile = function () {
  return (window.matchMedia('(max-width: '+ APP.bp.mobile +'px)').matches)
}

var isPortrait = function() {
  let defaultOrientation = null;
  if('orientation' in window) {
    var o1 = (window.innerWidth < window.innerHeight);
    var o2 = (window.orientation % 180 == 0);
    defaultOrientation = (o1 && o2) || !(o1 || o2);
  }
  if('orientation' in window) {
    // defaultOrientationがtrueの場合、window.orientationが0か180の時は縦
    // defaultOrientationがfalseの場合、window.orientationが-90か90の時は横
    var o = (window.orientation % 180 == 0);
    if((o && defaultOrientation) || !(o || defaultOrientation)) {
      return true;
    } else {
      return false;
    }
  }
}
// 参考サイト
// https://hacknote.jp/archives/15289/

var cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class FormCheck {
  constructor(el, opt) {
    this.el = el;
    this.event();
  }
  event() {
    const radioButtons = document.querySelectorAll('input[type="radio"]');
    const formElements = document.querySelector('.form-elements');
    const receptionMessage = document.querySelector('.reception__message');
    receptionMessage.style.display = "none";

    if($('.error').length >= 1) {
      $('.form-elements').removeClass('disable');
    }
    

    radioButtons.forEach(radioButton => {
      radioButton.addEventListener('change', function() {
        if (radioButton.value === 'true') {
          formElements.classList.remove('disable');
          receptionMessage.style.display = "none";
        } else if (radioButton.value === 'false') {
          formElements.classList.add('disable');
          receptionMessage.style.display = "block";
        }
      });
    });
  }
}

//noScroll
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    this.para_ele = document.querySelectorAll("." + this.el);
    this.para_ele.forEach((ele, index)=> {
      if(ele.classList.contains('js-parallax--reverse')) {
        this.translateY = '20px';
      } else {
        this.translateY = '-20px';
      }
      ele.classList.add(this.el + index);
      gsap.to('.' + this.el + index + ' img', {
        translateY: this.translateY,
        scrollTrigger: {
          trigger: '.' + this.el + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          scrub: 3,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    this.el = el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

class ModalEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event() {
    const buttonOpen = document.querySelectorAll('.modalOpen');
    const modal = document.querySelector('.modal');
    const buttonClose = document.querySelector('.modalClose');
    const body = document.querySelector('body');

    buttonOpen.forEach((el) => {
      el.addEventListener('click', function() {
        modal.classList.add('open');
        body.classList.add('open');
      });
    })
  
    // バツ印がクリックされた時
    buttonClose.addEventListener('click', function() {
      modal.classList.remove('open');
      body.classList.remove('open');
    });

    // モーダルコンテンツ以外がクリックされた時
    modal.addEventListener('click', function(){ 
      modal.classList.remove('open');
      body.classList.remove('open');
    });
  }
}

// class Participation {
//   constructor(el,opt){
//     this.el = el;
//     if($("#" + this.el).length > 0){
//       this.event();
//     }
//   }
//   event() {

//     $('.js-form-num [name="radio"]').each((index, el) => {
//       if($(el).prop('checked')) {
//         elEach(index);
//       }
//     });
    
//     $('.js-form-num .mwform-radio-field').on('click', function() {
//       elEach($(this).index());
//     })

//     if($('.mw_wp_form_confirm').length) {
//       let val = Number($('[name="radio"]').val().split('人')[0]) - 1;
//       elEach(val);
//     }

//     function elEach(num_index) {
//       console.log(num_index);
//       $('.js-form-result').each((index, el) => {
//         if(num_index >= index) {
//           $(el).css({'display': 'block'});
//         } else {
//           $(el).css({'display': 'none'});
//         }
//       })
//     }
//   }
// }
class SlideAnime {
  constructor(){
    this.event();
  }
  event(){
    const btn = document.getElementById('btnText');

    $('.sp-menu').click(function() {
        $(this).toggleClass('active');
        if ($(this).hasClass('active')) {
            btn.textContent = 'CLOSE';
            $('.globalMenuSp').addClass('active');
        } else {
            btn.textContent = 'MENU';
            $('.globalMenuSp').removeClass('active');
        } 
    });
    $('.globalMenuSp a[href]').click(function() {
        $('.globalMenuSp').removeClass('active');
        $('.sp-menu').removeClass('active');
    });
  }
}

class SmoothScroll {
  constructor(el, opt) {
    this.el = el;
    this.event();
  }
  event() {
    var headerHeight = 0; //fixedのヘッダーの高さを取得
    var urlHash = location.hash; //URLハッシュを取得
    var animeSpeed = 500; //スクロールのアニメーションスピード
    if (urlHash) {
      $("body,html").stop().scrollTop(0);
      setTimeout(function () {
        var target = $(urlHash);
        var position = target.offset().top - headerHeight;
        $("body,html").stop().animate({ scrollTop: position }, animeSpeed);
      }, 100);
    }
    $('a[href*="#"]').on({
      click: function () {
        var href = $(this).attr("href");
        href = href.split("#");
        var target = $("#" + href[1]);
        var position = target.offset().top - headerHeight;
        $("body,html").stop().animate({ scrollTop: position }, animeSpeed);
      },
    });
  }
}



(() => {

})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {

  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
  let slideAnime = new SlideAnime('.hamburger');
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('.js-inview');
  let accordionEvent = new AccordionEvent('.js-accordion');
  let smoothScroll = new SmoothScroll('');
  let modalEvent = new ModalEvent('js-modal');
  let achievement = new Achievement('mw_wp_form_mw-wp-form-18');
  // let participation = new Participation('mw_wp_form_mw-wp-form-19');
  let formCheck = new FormCheck('reception');
});

// スマホ・タブレットの向き判定
// $(window).on('orientationchange', ()=>{
//   if(isPortrait()){
//     console.log('isPortrait');
//   } else {
//     console.log('isLandscape');
//   }
// });